/**
 * Pure setters for the Account Settings orchestrator. Mixed into the React
 * component via `Inherit(ClockoutController, AccountDelegate)`, so `this`
 * inside these methods resolves to the React component instance.
 *
 * Validation-aware behaviours (save / cancel / submit) live on the controller
 * — placing them here would break their `this` binding because `Inherit`
 * copies mixin instance fields from a throwaway instance, capturing the
 * wrong lexical `this`.
 */
class AccountDelegate {
    setFirstName(firstName) {
        this.setState({ firstName });
    }

    setLastName(lastName) {
        this.setState({ lastName });
    }

    setEmail(email) {
        this.setState({ email });
    }

    setPhoneNumber(phoneNumber) {
        this.setState({ phoneNumber });
    }

    setCurrentPassword(currentPassword) {
        this.setState({ currentPassword });
    }

    setNewPassword(newPassword) {
        this.setState({ newPassword });
    }

    setConfirmPassword(confirmPassword) {
        this.setState({ confirmPassword });
    }

    setErrorMessage(errorMessage) {
        this.setState({ errorMessage });
    }

    setSuccessMessage(successMessage) {
        this.setState({ successMessage });
    }

    /**
     * Flips the password section open/closed. When closing, also clears the
     * three password inputs and any error so the next open lands on a clean
     * form.
     */
    handleTogglePasswordSection() {
        const { showPasswordSection } = this.state;

        if (showPasswordSection) {
            this.setState({
                showPasswordSection: false,
                currentPassword: '',
                newPassword: '',
                confirmPassword: '',
                errorMessage: '',
            });
            return;
        }

        this.setState({ showPasswordSection: true });
    }
}

export default AccountDelegate;
